import React from 'react'
import { twMerge } from 'tailwind-merge'

function CheckIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={twMerge('text-background-secondary', props.className)}
    >
      <path
        d="M0.999756 7.84424L4.99976 11.8442L14.9998 1.84424"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CheckIcon
